import React from 'react'
import PropTypes from 'prop-types'

import styles from './ClearSearch.scss'

export const ClearSearch = ({ onClick }) => (
  <button type='button' className={styles.clearIcon} onClick={onClick} data-test='search-clear-icon' />
)

ClearSearch.propTypes = {
  onClick: PropTypes.func,
}

ClearSearch.defaultProps = {
  onClick: () => {},
}

export default ClearSearch
